import React from "react";
import PrintInvoiceWrapper from "./printInvoice.style";
import fileDownloader, { prinInvoiceCall } from "./helper/helper";
import { message } from "antd";
import { FILE_DOWNLOADED } from "../../../constants";

export const PrintInvoice = ({ access_token, toId }) => {
  const downloadInvoice = () => {
    prinInvoiceCall({ access_token, toId })
      .then((res) => {
        if (res.status === 200 && res?.data?.responseData) {
          fileDownloader(res.data.responseData);
          message.success(FILE_DOWNLOADED);
        } else {
        }
      })
      .catch((err) => {
        message.error(err.message);
      });
  };
  return (
    <PrintInvoiceWrapper>
      <button className="bbtn" onClick={downloadInvoice}>
        Print Invoice
      </button>
    </PrintInvoiceWrapper>
  );
};

export default PrintInvoice;
